import { all, call, put, takeLatest } from "redux-saga/effects";
import { GET_LIST_MAU_IN, GET_NOI_DUNG_IN } from "actions/InChoVay/actionTypes";
import {
  getListMauInSuccess,
  getListMauInFailure,
  getNoiDungInSuccess,
  getNoiDungInFailure,
} from "actions/InChoVay";
import { pushNotification } from "utils/notifications";
import InChoVayApi from "service/inChoVayApi";

function* getListMauIn(action) {
  try {
    const response = yield call(InChoVayApi.combo, {});
    if (response.ok) {
      if (response.data.Error) {
        pushNotification(response.data.Message, "error", "TOP_CENTER", 2000);
        yield put(getListMauInFailure());
      } else {
        yield put(getListMauInSuccess(response.data));
      }
    } else {
      pushNotification("Lỗi xảy ra.", "error", "TOP_CENTER", 2000);
      yield put(getListMauInFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra.", "error", "TOP_CENTER", 2000);
    yield put(getListMauInFailure());
  }
}
function* getNoiDungIn(action) {
  try {
    const response = yield call(InChoVayApi.getInChoVay, action.dataSearch);
    if (response.ok) {
      if (response.data.Error) {
        pushNotification(response.data.Message, "error", "TOP_CENTER", 2000);
        yield put(getNoiDungInFailure());
      } else {
        yield put(getNoiDungInSuccess(response.data));
      }
    } else {
      pushNotification("Lỗi xảy ra.", "error", "TOP_CENTER", 2000);
      yield put(getNoiDungInFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra.", "error", "TOP_CENTER", 2000);
    yield put(getNoiDungInFailure());
  }
}

function* watchGetRequest() {
  yield takeLatest(GET_LIST_MAU_IN, getListMauIn);
  yield takeLatest(GET_NOI_DUNG_IN, getNoiDungIn);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
